import { fg } from '@atlassian/jira-feature-gating';

const WivFixRedirectionIssueKeyRelayProvider = {
	get(): boolean {
		return fg('wiv-fix-redirection-issue-key');
	},
};

export default WivFixRedirectionIssueKeyRelayProvider;
